import { ID, Task, TaskActionType } from '@griply/types';

import { taskGoalIds } from '../links/task-link-ids';

// Replaces goal.taskCount, which drifts — it is maintained by increment(±1).
export const buildGoalOpenTaskCounts = (tasks: Task[]): Map<ID, number> => {
  const counts = new Map<ID, number>();

  tasks.forEach((task) => {
    if (task.completedAt || task.archivedAt) {
      return;
    }

    if (task.action?.type === TaskActionType.GoalTimeslot) {
      return;
    }

    // A task linked to several goals is open work for each of them.
    taskGoalIds(task).forEach((goalId) =>
      counts.set(goalId, (counts.get(goalId) ?? 0) + 1),
    );
  });

  return counts;
};
